import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import type { OpportunityStatusOldType } from '@/api/opportunity';
import { Panel } from '@/components/panels';
import { Tabs, TabsList, TabsTrigger } from '@/components/Tabs';
import { OpportunityInfluenceChartTableCombo } from '@/features/OpportunityInfluenceChartTableCombo';

type Props = {
  vendorIds?: string[];
  isLoading?: boolean;
  groupBy?: 'CAMPAIGN' | 'VENDOR' | 'TAG';
};

const VendorOpportunityInfluenceChartTable = ({ vendorIds, isLoading, groupBy }: Props) => {
  const [opportunityType, setOpportunityType] = useState<OpportunityStatusOldType>('pipeline');

  const options: { value: OpportunityStatusOldType; label: string }[] = [
    { value: 'pipeline', label: t`Pipeline` },
    { value: 'closedWon', label: t`Closed Won` },
  ];

  return (
    <Panel
      title={<Trans>Opportunity Influence</Trans>}
      noPadding
      isFullHeight
      actions={
        <Tabs
          value={opportunityType}
          onValueChange={(value) => setOpportunityType(value as OpportunityStatusOldType)}
        >
          <TabsList>
            {options.map((option) => (
              <TabsTrigger key={option.value} value={option.value}>
                {option.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      }
    >
      <OpportunityInfluenceChartTableCombo
        opportunityType={opportunityType}
        isLoading={isLoading}
        vendorIds={vendorIds}
        groupBy={groupBy}
      />
    </Panel>
  );
};

export default VendorOpportunityInfluenceChartTable;
